import React, {useCallback, useState, useContext, useEffect} from 'react';
import {Popup, Input, Checkbox, Button, setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview, NavItem, TabNav} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderUser.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Empty from "../utils/Empty";
import Loading from "../utils/Loading";
import dayjs from "dayjs";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderUser({locale, dialog, Dialog, user, Logout, setUser, width}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [notifications, setNotifications] = useState(user.notifications);
    const [mobile, setMobile] = useState(user.type === 'mobile' ? user.id : user.mobile);
    const [email, setEmail] = useState(user.type === 'email' ? user.id : user.email);
    const [firstName, setFirstName] = useState(user.firstName);
    const [lastName, setLastName] = useState(user.lastName);
    const [usage, setUsage] = useState([]);
    const [summary, setSummary] = useState({});
    const [tab, setTab] = useState('general');
    const [loading, setLoading] = useState(true);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const Usage = () => {

        const message = {
            type: 'wss',
            path: 'user-usage',
            action: 'get',
            data: {
                date: dayjs().format("YYYY-M-D")
            }
        };
        wsCall(message);
    }

    const ItemSave = () => {

        const item = {...user};
        item.notifications = notifications;
        item.firstName = firstName;
        item.lastName = lastName;
        setUser(item);

        const message = {
            type: 'wss',
            path: 'user',
            action: 'update',
            data: {}
        }
        if (firstName !== user.firstName) {
            message.data.firstName = firstName;
        }
        if (lastName !== user.lastName) {
            message.data.lastName = lastName;
        }
        if (notifications !== user.notifications) {
            message.data.notifications = notifications;
        }
        if (email !== user.email) {
            message.data.email = email;
        }
        if (mobile !== user.mobile) {
            message.data.mobile = mobile;
        }
        wsCall(message);
    }

    const ButtonClose = () => {
        if (notifications !== user.notifications ||
            email !== user.email ||
            mobile !== user.mobile ||
            firstName !== user.firstName ||
            lastName !== user.lastName) {
            ItemSave();
        } else {
            DialogClose();
        }
    }

    const ListItem = data => {
        const id = data.item.model;

        return <li data-id={id} className="cs-dashboard-header-user-list-multi" >
            <div className="mbsc-row cs-dashboard-header-user-list" >
                <div>
                    <div className="mbsc-txt-muted">
                        <span className="mbsc-bold">{data.item.short}</span>
                        <span className="mbsc-bold cs-dashboard-header-user-button-nav">&nbsp;|&nbsp;</span>
                        {data.item.tokensTotal ?
                            <>{data.item.tokensTotal.toLocaleString('en-US')} {locale.dashboardHeaderUser.o}</>
                            :
                            <>{data.item.itemOutput.toLocaleString('en-US')} {data.item.itemOutput === 1 ? locale.dashboardHeaderUser.t : locale.dashboardHeaderUser.s}</>
                        }
                        <span className="mbsc-bold cs-dashboard-header-user-button-nav">&nbsp;|&nbsp;</span>
                        {data.item.percentage}%
                    </div>
                </div>
            </div>
        </li>;
    }

    const GetUserUsage = useCallback(data => {
        if (data.usage) {
            setUsage(data.usage);
        }
        if (data.summary) {
            setSummary(data.summary);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'user-usage') {
            GetUserUsage(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetUserUsage, setWsResponse]);

    useEffect(() => {
        Usage();
    }, []);

    return (
        <Popup className="cs-dashboard-header-user-popup" width={600} maxHeight={750} display="center" scrollLock={false} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderUser'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-header-user-header-col">
                <div className="mbsc-row cs-dashboard-header-user-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-header-user-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-header-user-header-col mbsc-align-center" : "mbsc-col cs-dashboard-header-user-header-col"} >
                        <Button className="cs-dashboard-header-user-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {locale.dashboardHeaderUser.c}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-user-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-user-close-button" onClick={() => ButtonClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-header-user-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            <div className="mbsc-grid cs-dashboard-header-user-header-col">
                <div className="mbsc-row cs-dashboard-header-user-header-row mbsc-justify-content-center">
                    <div style={{backgroundImage: "url(https://www.gravatar.com/avatar/" + user.avatar + "?d=robohash)"}} className="cs-dashboard-header-user-avatar" />
                </div>
                <div className="mbsc-row cs-dashboard-header-user-header-row mbsc-padding mbsc-justify-content-center cs-dashboard-header-user-link">
                    <a href="https://en.gravatar.com" target="_blank">
                        {locale.dashboardHeaderUser.h}
                    </a>
                </div>
            </div>
            {loading &&
                <Loading />
            }
            {!loading &&
                <TabNav theme="mobiscroll" themeVariant="light" display='inline' className="cs-dashboard-header-user-nav-tab" >
                    <NavItem selected={tab === 'general'} onClick={() => tab !== 'general' && setTab('general')} >
                        <span className={tab === 'general' ? 'mbsc-bold cs-dashboard-header-user-button-nav' : ''} >{locale.dashboardHeaderUser.l}</span>
                    </NavItem>
                    <NavItem selected={tab === 'usage'} onClick={() => tab !== 'usage' && setTab('usage')} >
                        <span className={tab === 'usage' ? 'mbsc-bold cs-dashboard-header-user-button-nav' : ''} >{locale.dashboardHeaderUser.n}</span>
                    </NavItem>
                </TabNav>
            }
            {!loading && tab === 'general' &&
                <div className="mbsc-form-group">
                    <Input disabled={user.type === 'mobile'} inputStyle="underline" label={locale.dashboardHeaderUser.f} labelStyle="floating" type="tel" name="mobile" value={mobile} onChange={ev => setMobile(ev.target.value)}/>
                    <Input disabled={user.type === 'email'} placeholder={user.email ? locale.dashboardHeaderUser.m : locale.dashboardHeaderUser.d} inputStyle="underline" label={user.email ? locale.dashboardHeaderUser.d : locale.dashboardHeaderUser.m} labelStyle="floating" type="text" name="email" value={email} onChange={ev => setEmail(ev.target.value)}/>
                    <Input inputStyle="underline" label={locale.dashboardHeaderUser.a} labelStyle="floating" type="text" name="firstName" value={firstName} onChange={ev => setFirstName(ev.target.value)}/>
                    <Input inputStyle="underline" label={locale.dashboardHeaderUser.b} labelStyle="floating" type="text" name="lastName" value={lastName} onChange={ev => setLastName(ev.target.value)}/>
                    <Checkbox
                        color="info"
                        label={locale.dashboardHeaderUser.i}
                        checked={notifications}
                        onChange={(ev) => setNotifications(ev.target.checked)}
                    />
                    <div className="cs-dashboard-header-user-helper mbsc-txt-muted">
                        <p>{locale.dashboardHeaderUser.j} {user.sessions.length} {locale.dashboardHeaderUser.k}</p>
                    </div>
                </div>
            }
            {!loading && tab === 'usage' &&
                <>
                    <div className="cs-dashboard-header-user-helper">
                        <p>{locale.dashboardHeaderUser.p}</p>
                    </div>
                    <div className="cs-dashboard-header-user-scroll">
                        <Listview
                            theme="ios"
                            themeVariant="light"
                            select="single"
                            itemType={ListItem}
                            data={usage}
                        />
                    </div>
                    <div className="mbsc-button-group-block cs-dashboard-header-user-summary-block">
                        <Button color="primary" variant="flat" className="cs-dashboard-header-user-button-summary mbsc-txt-muted" >
                            {summary.itemOutput && summary.itemOutput !== 0 &&
                                <>
                                    <span className="mbsc-bold" >{locale.dashboardHeaderUser.s}:&nbsp;{summary.itemOutput.toLocaleString('en-US')}</span>
                                    <span className="mbsc-bold" >&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                </>
                            }
                            <span className="mbsc-bold" >{locale.dashboardHeaderUser.q}:&nbsp;{summary.tokensTotal.toLocaleString('en-US')}</span>
                            <span className="mbsc-bold" >&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-bold" >{locale.dashboardHeaderUser.r}:&nbsp;${summary.tokensTotalCost.toFixed(2)}</span>
                        </Button>
                    </div>
                </>
            }
            <div className="mbsc-button-group-justified cs-dashboard-header-user-nav-buttons">
                <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-user-nav-button" onClick={() => Dialog({view: 'dashboardHeaderReset'})} >
                    {locale.dashboardHeaderUser.g}
                </Button>
                <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-user-nav-button" onClick={() => Logout('all')} >
                    {locale.dashboardHeaderUser.e}
                </Button>
            </div>
        </Popup>
    );
}

export default DashboardHeaderUser;
